<template>
	<section id="contact">
		<b-container fluid class="set_size">
			<div>
				<b-row class="spaces-contact" align-h="center">
					<b-col id="sm-r10" cols="11" sm="10" md="5" lg="5" xl="5">
						<div class="target-contact">
							<div class="target-paint text-center"><b-img :src="require('../../assets/mar/img/resource3.png')" fluid alt="Responsive image"></b-img></div>
							<div>
								<h2 class="text-center">¡CONTÁCTANOS!</h2>
							</div>
							<div class="target-info">
								<table>
									<tr>
										<td><div class="div-first"><icon-base icon-name="Phone"><icon-phone /></icon-base></div></td>
										<td>
											<div class="div-first"><a class="footer_hover" href="https://wa.me/5215540397847" target="_blank"><span>+52 1 55 4039 7847</span></a></div>
										</td>
									</tr>
									<tr>
										<td><div class="div-second"><icon-base icon-name="Envelope"><icon-envelope /></icon-base></div></td>
										<td>
											<div class="div-second">
												<a class="footer_hover" href="mailto:hellomar@marabunta.work">hellomar@marabunta.work</a>
											</div>
										</td>
									</tr>
									<tr>
										<td><div class="div-third"><icon-base icon-name="Geo"><icon-geo /></icon-base></div></td>
										<td>
											<div>
												<a class="footer_hover" href="https://www.google.com.mx/maps/place/WeWork+Centtral+Interlomas/@19.3927744,-99.282897,17z/data=!3m1!4b1!4m12!1m6!3m5!1s0x85d207ab854ce0d5:0x55c364b284251515!2sWeWork+Centtral+Interlomas!8m2!3d19.3927694!4d-99.2807083!3m4!1s0x85d207ab854ce0d5:0x55c364b284251515!8m2!3d19.3927694!4d-99.2807083" target="_blank">Palmas Hills 1, Valle de las <br> Palmas, 52763. <br> Ciudad de México, Méx.</a>
											</div>
										</td>
									</tr>
								</table>  
							</div>
							<div class="icons-media">
								<a class="contact_hover inst-icon" href="https://www.instagram.com/marbymarabunta/?hl=es-la" target="_blank"><icon-base icon-color="#1284A8" width="28" height="28" icon-name="Instagram"><icon-instagram /></icon-base></a>
								<a class="contact_hover" href="https://www.facebook.com/Mar-by-Marabunta-110420844079706" target="_blank"><icon-base icon-color="#1284A8" width="32" height="32" icon-name="Facebook"><icon-facebook /></icon-base></a>
							</div>
						</div>
					</b-col>
					<b-col id="sm-r12" cols="12" sm="12" md="7" lg="7" xl="7">
						<div class="panel-white"></div>
						<div>
							<b-row class="white-responsive" align-h="center">
								<b-col cols="11" sm="10" md="12" lg="11" xl="10">
									<div class="txt-contact text-center">
										<b-img :src="require('../../assets/mar/img/Logo_Mar.png')" fluid alt="Responsive image"></b-img>
										<p>
											En Mar siempre estamos dispuestas a combatir nuevos retos y crear experiencias eficaces. Estamos ansiosas por escuchar tu idea.
										</p>
									</div>
								</b-col>
								<b-col cols="11" sm="10" md="11" lg="11" xl="10" :class="animationSendForm">
									<b-form @submit="checkFormMar" class="formMar" v-if="show">
										<b-row class="myMar-4 mMar-r">
											<b-col cols="12">
												<b-form-input class="input-size2" v-model="form.name" placeholder="Nombre:" required maxlength="50"></b-form-input>
											</b-col>
										</b-row>
										<b-row class="myMar-4 mMar-r">
											<b-col cols="12">
												<b-form-input class="input-size2" v-model="form.email" type="email" placeholder="Correo" required maxlength="50"></b-form-input>
											</b-col>
										</b-row>
										<b-row class="myMar-4 mMar-r">
											<b-col cols="12">
												<b-form-input class="input-size2" v-model="form.issue" placeholder="Asunto" required maxlength="50"></b-form-input>
											</b-col>
										</b-row>
										<b-row class="myMar-4 mMar-r">
											<b-col cols="12">
												<div>
													<multiselect 
														v-model="form.value" 
														:options="options" 
														:multiple="true" 
														:close-on-select="false" 
														:clear-on-select="false" 
														:preserve-search="true" 
														placeholder="Servicio de tu interés (Opcional)" 
														label="name" 
														track-by="name"
														:showLabels="false">
														<template slot="tag"><span v-show="showTags"></span></template>
														<template slot="selection" slot-scope="{ values, search, isOpen }">
															<span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Opcion(es)</span>
														</template>
														<span slot="noResult">Sin resultados.</span>
													</multiselect>
												</div>
											</b-col>
										</b-row>
										<b-row class="myMar-4 mMar-r">
											<b-col cols="12">
												<b-form-input class="input-size2" v-model="form.budget" placeholder="Presupuesto aproximado (Opcional):" maxlength="50"></b-form-input>
											</b-col>
										</b-row>
										<b-row class="myMar-4 mMar-r">
											<b-col cols="12">
												<b-form-textarea v-model="form.message" rows="8" no-resize placeholder="Mensaje:" required maxlength="300"></b-form-textarea>
											</b-col>
										</b-row>
										<b-row class="myMar-4 mMar-r">
											<b-col cols="12" sm="12" md="12" lg="12" xl="10">
												<div class="msgErrorMar">
													<span>{{ msgError }}</span>
												</div>
											</b-col>
										</b-row>
										<b-row align-h="end">
											<b-col cols="12" class="btn-mar-send text-right">
												<button type="submit" class="btn-send-mar">ENVIAR</button>
											</b-col>
										</b-row>
									</b-form>
								</b-col>
								<b-col cols="12" sm="10" md="11" lg="11" xl="11" :class="row_shipment">
									<div class="confirmMar">
										<span>¡GRACIAS!</span>
										<p>
											¡Hemos recibido tu mensaje!
											<br>
											Nos comunicaremos contigo tan pronto como podamos.
										</p>
										<button @click="returnFormMar" class="btn-send-mar">ACEPTAR</button>
									</div>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
				<b-row cols="7" class="arrow-separation">
					<b-col>
						
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12"><div class="up-content"></div></b-col>
					<b-col cols="12">
						<div class="up-styles-mar">
							<a class="btn-up-mar" href="#home-mar">
							<span>SUBIR</span>
								<icon-base class="arrow-up" icon-name="Arrow" style="position: absolute; top: 7px; right: -24px;">
									<icon-arrow />
								</icon-base>
								</a>
						</div>
					</b-col>
				</b-row>
			</div>
		</b-container>
	</section>
</template>

<style>
	.spaces-contact{
		margin-right: 5% !important;
		margin-left: 5% !important;
	}
	.title-mar-separation{
		padding-top: 80px;
	}
	.formMar input::placeholder, .formMar textarea::placeholder{
		color: #1D2B3C;
	}
	.formMar .multiselect__input, .formMar .multiselect__single{
		margin-top: 11px;
		background-color: #EFEFEF;
	}
	.formMar input, .formMar textarea, .formMar .multiselect__tags{
		border-radius: 0;
		background-color: #EFEFEF;
		color: #1D2B3C;
		font-size: 18px;
		font-family: "Gotham Book Regular";
		letter-spacing: 0px;
		line-height: 21px;
	}
	.formMar .multiselect__tags{
		padding-top: 10px;
	}
	.formMar .multiselect__select{
		top: 10px;
	}
	.myMar-4{
		margin-bottom: 1.5rem;
		margin-top: 1.5rem;
	}
	.panel-white{
		position: absolute;
		background-color: #ffffff;
		width: 135%;
		height: 100%;
		right: 15px;
	}
	.txt-contact{
		margin-bottom: 50px;
		margin-top: 60px;
		margin-right: 5%;
		margin-left: 5%;
	}
	.txt-contact img{
		margin-bottom: 80px;
	}
	.txt-contact p{
		color: #1D1D1D;
    font-family: "Gotham Book Regular";
    font-size: 20px;
    letter-spacing: 1.54px;
    line-height: 28px;
	}
	.target-contact{
		position: relative;
		background-color: #A9E8DC;
		padding-bottom: 30px;
		top: 50%;
		-ms-transform: translateY(-50%);
		transform: translateY(-50%);
		z-index: 1;
	}
	.target-paint img{
		margin-top: -5%;
	}
	.target-paint{
		margin-bottom: 80px;
	}
	.target-contact h2{
		color: #1D2B3C;
    font-family: "Baskerville";
    font-size: 40px;
    letter-spacing: 3.08px;
    line-height: 46px;
	}
	.target-info svg{
		color: #1284A8;
		width: 28px;
		height: 28px;
		font-size: 30px;
		margin-right: 15px;
	}
	.target-info{
    margin-top: 80px;
		padding: 0 60px;
	}
	.target-info .div-first{
		margin-bottom: 35px;
	}
	.target-info .div-second{
		margin-bottom: 35px;
	}
	.target-info .div-third{
		margin-top: -35px;
	}
	.target-info a{
		color: #1D1D1D;
    font-family: "Gotham Book Regular";
    font-size: 20px;
    letter-spacing: 1.54px;
    line-height: 28px;
	}
	.target-info a:hover{
		text-decoration: none;
	}
	.icons-media{
		margin-top: 50px;
		text-align: center;
	}
	.icons-media a:first-child{
		margin-right: 10px;
	}
	.icons-media a:last-child{
		margin-left: 10px;
	}
	.icons-media .inst-icon svg path{
		stroke: #1284A8 !important;
	}
	.msgErroMar{
		font-family: "Gotham light Regular";
		position: absolute;
		color: #1D1D1D;
	}
	.btn-mar-send{
		margin-top: 65px;
		margin-bottom: 90px;
	}
	.btn-mar-send a{
    font-size: 20px;
    color: #1D1D1D;
    border-bottom: 2px solid #AFC5D9;
    opacity: 1;
    display: inline-block;
    padding-bottom: 4px;
    line-height: 28px;
  }
  .btn-mar-send button:hover{
		color: #1D1D1D;
    border-bottom: 2px solid #04182E;
  }
	.btn-send-mar{
    color: #1D1D1D;
		font-family: "Gotham Book Regular";
		font-size: 20px;
		border-bottom: 2px solid #AFC5D9;
		background: transparent;
		text-decoration: none;
		border-right: none;
		border-left: none;
		border-top: none;
	}
	.arrow-separation{
		margin-top: 250px;
	}
	.successful_mar{
		display: none !important;
	}
	.confirmMar{
		position: absolute;
		margin-left: auto;
		margin-right: auto;
		left: 0;
		right: 0;
		text-align: center;
		top: -650px;
	}
	.confirmMar span{
		font-family: "Baskerville";
		color: #1D1D1D;
		font-size: 40px;
		letter-spacing: 3.46px;
		line-height: 52px;
	}
	.confirmMar p{
		font-family: "Gotham Book Regular";
		color: #1D1D1D;
		font-size: 20px;
		line-height: 40px;
		letter-spacing: 1.54px;
		margin: 3% 0% 5% 0%;
	}
	.contact_hover:hover svg g{
		fill: #1D1D1D !important;
	}
	.icons-media .inst-icon:hover svg path{
		stroke: #1D1D1D !important;
	}
	.up-styles-mar{
		color: #04182E;
		font-size: 20px;
		position: absolute;
		bottom: 100px;
		right: 0px;
		line-height: 28px;
		letter-spacing: 1.54px;
		-webkit-transform: rotate(-90deg); 
		-moz-transform: rotate(-90deg);
		-o-transform: rotate(-90deg);
		transform: rotate(-90deg);
	}
	.btn-up-mar[href]{
		color: #04182E;
		text-decoration: none;
		font-family: "Gotham Medium Regular";
	}
	.input-size2{
		height: 60px !important;
	}
	@media (max-width: 1800px) {
		.txt-contact p{
			font-size: 16px;
			letter-spacing: 1.23px;
			line-height: 25px;
		}
		.formMar input, .formMar textarea, .formMar .multiselect__tags{
			font-size: 16px;
			line-height: 18px;
		}
		.formMar .multiselect__input, .formMar .multiselect__single{
			margin-top: 10px;
		}
		/* .target-contact{
			width: 130%;
			margin-left: -70%;
		} */
		.confirmMar span{
			font-size: 36px;
		}
		.target-contact h2{
			font-size: 36px;
			letter-spacing: 2.8px;
			line-height: 35px;
		}
		.target-info a{
			font-size: 16px;
			letter-spacing: 1.23px;
			line-height: 25px;
		}
		.confirmMar span{
			font-size: 40px;
		}
		.confirmMar p{
			font-size: 16px;
			line-height: 45px;
		}
		.up-styles-mar{
			font-size: 16px;
			line-height: 22px;
			letter-spacing: 1.23px;
		}
		.up-styles-mar .arrow-up{
			top: 4px !important;
		}
	}
	@media (max-width: 1600px){
		.btn-send-mar{
			font-size: 16px;
		}
		.input-size2{
			height: 55px !important;
		}
		.formMar .multiselect__tags{
			height: 55px !important;
			padding-top: 6px;
		}
		.formMar .multiselect__placeholder {
			padding-top: 12px;
		}
		.formMar .multiselect__select{
			top: 8px;
		}
		.formMar .multiselect__input, .formMar .multiselect__single{
			margin-top: 11px;
		}
	}
	@media (max-width: 1400px){
		.target-paint{
			margin-bottom: 50px;
		}
		.target-paint img{
			width: 45%;	
		}
		.txt-contact{
			margin-right: 2%;
			margin-left: 2%;
		}
		.txt-contact img{
			margin-bottom: 60px;
			width: 30%;
		}
		.target-info{
			padding: 0 20px;
		}
		.spaces-contact{
			margin-right: 4% !important;
			margin-left: 4% !important;
		}
		.confirmMar{
			top: -600px;
		}
		.confirmMar span{
			letter-spacing: 3px;
			line-height: 40px;
		}
		.confirmMar p{
			line-height: 40px;
			letter-spacing: 1.30px;
			margin: 3% 2% 5% 2%;
		}
	}
	@media (max-width: 1200px) {
		.spaces-contact{
			margin-right: 0% !important;
			margin-left: 0% !important;
		}
		.target-contact h2 {
			font-size: 30px;
			letter-spacing: 2px;
			line-height: 20px;
		}
		.confirmMar span{
			font-size: 30px;
		}
		.btn-mar-send{
			margin-top: 30px;
			margin-bottom: 50px;
		}
		.arrow-separation {
			margin-top: 100px;
		}
		.up-content {
			height: 100px;
		}
		.up-styles-mar{
			bottom: 50px;
		}
		.confirmMar{
			top: -580px;
		}
	}
	@media (max-width: 1024px) {
		.txt-contact p {
			line-height: 28px;
		}
		.txt-contact {
			margin-bottom: 30px;
		}
		.txt-contact img {
			margin-bottom: 40px;
			width: 25%;
		}
		.formMar input, .formMar textarea, .formMar .multiselect__tags {
			font-size: 16px;
			line-height: 28px;
		}
		.mMar-r{
			margin-top: 16px;
			margin-bottom: 16px;
		}
		.formMar .multiselect__placeholder {
			padding-top: 0px;
		}
		.input-size2{
			height: 40px !important;
		}
		.formMar .multiselect__tags{
			height: 40px !important;
		}
		.formMar .multiselect__select{
			top: 2px;
		}
		.formMar .multiselect__input, .formMar .multiselect__single{
			margin-top: 0px;
		}
		.btn-mar-send {
			margin-top: 20px;
			margin-bottom: 50px;
		}
		.target-contact h2 {
			font-size: 25px;
			letter-spacing: 1.93px;
			line-height: 28px;
		}
		.target-info a {
			font-size: 14px;
			letter-spacing: 1.08px;
			line-height: 28px;
		}
		.btn-send-mar {
			line-height: 22px;
		}
	}
	@media (max-width: 960px) {
		.confirmMar span{
			font-size: 24px;
		}
		.confirmMar{
			top: -450px;
		}
		.confirmMar span{
			font-size: 28px;
		}
		.confirmMar p{
			font-size: 15px;
			line-height: 30px;
		}
		.up-styles-mar{
			font-size: 14px;
			line-height: 20px;
			letter-spacing: 1.08px;
		}
		.up-styles-mar .arrow-up{
			top: 2px !important;
		}
		.txt-contact {
			margin-bottom: 20px;
			margin-top: 30px;
		}
		.txt-contact img {
			margin-bottom: 30px;
		}
		.target-paint {
			margin-bottom: 30px;
		}
		.target-info {
			margin-top: 50px;
		}



		.spaces-contact{
			margin-right: -15px !important;
			margin-left: -15px !important;
		}
		.target-contact h2 {
			font-size: 20px;
			letter-spacing: 1.54px;
			line-height: 23px;
		}
		.target-info a {
			font-size: 14px;
			letter-spacing: 1px;
			line-height: 25px;
		}
		.target-info .div-first {
			margin-bottom: 20px;
		}
		.target-info .div-second {
			margin-bottom: 20px;
		}
		.txt-contact p {
			font-size: 14px;
			letter-spacing: 1.08px;
			line-height: 25px;
		}
		.formMar .multiselect__tags {
			padding-top: 9px;
		}
		.formMar input, .formMar textarea, .formMar .multiselect__tags {
			font-size: 14px;
			line-height: 20px;
		}
		.formMar .multiselect__input{
			margin-top: 0px;
		}
		.formMar .multiselect__single {
			font-size: 14px;
			margin-top: 1px;
		}
		.formMar .multiselect__placeholder {
			font-size: 14px;
		}
		.btn-send-mar {
			font-size: 15px;
			line-height: 21px;
		}


	}
	@media (max-width: 768px){
		#sm-r10{
			-webkit-box-flex: 0;
			-webkit-flex: 0 0 83.3333333333%;
			-ms-flex: 0 0 83.3333333333%;
			flex: 0 0 83.3333333333%;
			max-width: 83.3333333333%;
		}
		#sm-r12{
			-webkit-box-flex: 0;
			-webkit-flex: 0 0 100%;
      -ms-flex: 0 0 100%;
			flex: 0 0 100%;
			max-width: 100%;
		}
		.panel-white{
			display: none;
		}
		.white-responsive{
			background-color: #ffffff;
			margin-left: 0px !important;
			margin-right: 0px !important;
			margin-top: -50px;
		}
		.target-info {
			padding: 0 10%;
		}	
		.target-info .div-first {
			margin-bottom: 30px;
		}
		.target-info .div-second {
			margin-bottom: 30px;
		}
		.icons-media {
			margin-top: 30px;
			text-align: right;
			margin-left: 8%;
			margin-right: 8%;
		}
		.zIndex{
			z-index: 1;
		}
		.txt-contact{
			margin-top: 120px;
		}
		.btn-mar-send {
			margin-top: 30px;
			margin-bottom: 30px;
		}
		.arrow-separation {
			margin-top: 100px;
		}

		.target-paint {
			margin-bottom: 40px;
		}
		.target-paint img {
			width: 30%;
		}
		.target-contact h2 {
			font-size: 25px;
			letter-spacing: 1.93px;
			line-height: 28px;
		}
		.target-info a {
			font-size: 14px;
			letter-spacing: 1.08px;
			line-height: 28px;
		}
		.txt-contact img{
			width: 18%;
		}
		.txt-contact img {
			margin-bottom: 35px;
		}
		.txt-contact p {
			font-size: 16px;
			letter-spacing: 1.23px;
			line-height: 28px;
			margin-left: 8%;
			margin-right: 8%;
		}
		.formMar{
			margin-left: 5%;
			margin-right: 5%;
		}
		.formMar input, .formMar textarea, .formMar .multiselect__tags {
			font-size: 16px;
		}
		.formMar .multiselect__placeholder {
			font-size: 16px;
		}
		.formMar .multiselect__single {
			font-size: 16px;
			margin-top: 0px;
		}
		.btn-mar-send {
			margin-top: 30px;
			margin-bottom: 50px;
		}
		.btn-send-mar {
			font-size: 16px;
			line-height: 22px;
		}
	}
	@media (max-width: 767px){
		.txt-contact p {
			margin-left: 0%;
			margin-right: 0%;
		}
		.formMar{
			margin-left: 0%;
			margin-right: 0%;
		}
		.txt-contact img {
			width: 22%;
		}
	}
	@media (max-width: 575px){
		.icons-media {
			margin-top: 40px;
			text-align: center;
			margin-left: 0;
			margin-right: 0;
		}
	}
	@media (max-width: 450px){
		.target-paint img {
			width: 50%;
		}
		.target-contact h2 {
			font-size: 20px;
			letter-spacing: 1.54px;
			line-height: 23px;
		}
		.target-info a {
			font-size: 13px;
			letter-spacing: 1px;
			line-height: 20px;
		}
		.target-info .div-first {
			margin-bottom: 20px;
		}
		.target-info .div-second {
			margin-bottom: 20px;
		}
		.white-responsive {
			margin-top: -140px;
		}
		.txt-contact {
			margin-top: 200px;
		}
		.txt-contact img {
			width: 30%;
		}
		.txt-contact p {
			font-size: 14px;
			letter-spacing: 1.08px;
			line-height: 25px;
		}
		.formMar input, .formMar textarea, .formMar .multiselect__tags {
			font-size: 11px;
		}
		.formMar .multiselect__placeholder {
			font-size: 11px;
		}
		.formMar .multiselect__single {
			font-size: 11px;
			margin-top: 0px;
		}
		.formMar .multiselect__content{
			font-size: 11px;
		}
		.btn-send-mar {
			font-size: 13px;
			line-height: 19px;
		}
		.btn-mar-send {
			margin-top: 10px;
			margin-bottom: 40px;
		}
	}
	@media (max-width: 410px) {
		.target-info {
			padding: 0 5%;
		}
	}
	@media (max-width: 375px) {
		.txt-contact img {
			width: 40%;
		}
	}
</style>

<script>
import IconBase from './../IconBase'
import IconFacebook from './../icons/IconFacebook'
import IconInstagram from './../icons/IconInstagramV2'
import IconArrow from './../icons/IconArrowV2'
import IconPhone from './../icons/IconPhone'
import IconEnvelope from './../icons/IconEnvelope'
import IconGeo from './../icons/IconGeo'

export default {
	name: 'ContactMar',
	components: {
    IconBase,
    IconFacebook,
		IconInstagram,
		IconArrow,
		IconPhone,
		IconEnvelope,
		IconGeo
  },
	data(){
		return {
			msgError: "",
			animationSendForm: "",
      row_shipment: "successful_mar",
			errors: [],
			form: {
				name: '',
				email: '',
				issue: '',
				value: [],
        budget: '',
        message: ''
			},
			options: [
        { name: 'Creación de contenido' },
        { name: 'Asesorías' },
        { name: 'Branding' },
        { name: 'Website' },
        { name: 'Website con E-Commerce' },
        { name: 'Digital Events' },
        { name: 'Diseño Gráfico' },
        { name: 'Animaciones' }
      ],
			showTags: false,
			show: true
		}
	},
	methods: {
		returnFormMar(){
      this.msgError = "";
      this.form.email = '';
      this.form.name = '';
      this.form.issue = '';
      this.form.value = '';
      this.form.budget = '';
      this.form.message = '';

      this.show = false
      this.$nextTick(() => {
        this.show = true
      })

      this.animationSendForm = "animate__animated animate__fadeInRight";
      this.row_shipment = "animate__animated animate__fadeOutDownBig"
    },
		checkFormMar(evt){
			this.errors = [];

      if (!this.form.email) {
        this.errors.push('Correo requerido.');
      } else if (!this.validEmail(this.form.email)) {
        this.errors.push('Es requerido un correo valido.');
			}

			if (!this.errors.length) {
        this.animationSendForm = "animate__animated animate__fadeOutRight";
        this.row_shipment = "animate__animated animate__fadeInUpBig"
        var txt = JSON.stringify(this.form);
        var obj = JSON.parse(txt);
				// console.log(obj);
				this.sendEmailMar(obj);
      }else{
        // console.log(this.errors);
        this.msgError = "Es requerido un correo válido";
			}
			evt.preventDefault()
		},
		validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
		},
		sendEmailMar(obj){
			var htmlClient='<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:arial, "helvetica neue", helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0"><head><meta http-equiv="Content-Security-Policy" content="script-src "none"; connect-src "none"; object-src "none"; form-action "none";"><meta charset="UTF-8"><meta content="width=device-width, initial-scale=1" name="viewport"><meta name="x-apple-disable-message-reformatting"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta content="telephone=no" name="format-detection"><title></title>' 
				+'<!--[if (mso 16)]>'
        +'<style type="text/css">'
        +'a {text-decoration: none;}'
        +'</style>'
        +'<![endif]-->' 
        +'<!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]-->' 
        +'<!--[if gte mso 9]>'
        +'<xml>'
        +'<o:OfficeDocumentSettings>'
        +'<o:AllowPNG></o:AllowPNG>'
        +'<o:PixelsPerInch>96</o:PixelsPerInch>'
        +'</o:OfficeDocumentSettings>'
        +'</xml>'
        +'<![endif]--><style type="text/css">#outlook a {	padding:0;}.ExternalClass {	width:100%;}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div {	line-height:100%;}.es-button {	mso-style-priority:100!important;	text-decoration:none!important;}a[x-apple-data-detectors] {	color:inherit!important;	text-decoration:none!important;	font-size:inherit!important;	font-family:inherit!important;	font-weight:inherit!important;	line-height:inherit!important;}.es-desk-hidden {	display:none;	float:left;	overflow:hidden;	width:0;	max-height:0;	line-height:0;	mso-hide:all;}@media only screen and (max-width:600px) {p, ul li, ol li, a { font-size:16px!important; line-height:150%!important } h1 { font-size:30px!important; text-align:center; line-height:120%!important } h2 { font-size:26px!important; text-align:center; line-height:120%!important } h3 { font-size:20px!important; text-align:center; line-height:120%!important } h1 a { font-size:30px!important } h2 a { font-size:26px!important } h3 a { font-size:20px!important } .es-menu td a { font-size:13px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:block!important } .es-button { font-size:16px!important; display:block!important; border-left-width:0px!important; border-right-width:0px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } .es-desk-menu-hidden { display:table-cell!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }</style></head><body style="width:100%;font-family:arial, "helvetica neue", helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0"><div class="es-wrapper-color" style="background-color:#F6F6F6">' 
				+'<!--[if gte mso 9]>'
				+'<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">'
				+'<v:fill type="tile" color="#f6f6f6"></v:fill>'
				+'</v:background>'
				+'<![endif]--><table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top"><tr style="border-collapse:collapse"><td valign="top" style="padding:0;Margin:0"><table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%"><tr style="border-collapse:collapse"><td style="padding:0;Margin:0;background-color:#FFFFFF" bgcolor="#ffffff" align="center"><table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px"><tr style="border-collapse:collapse"><td align="left" style="padding:5px;Margin:0"><table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td class="es-m-p0r" valign="top" align="center" style="padding:0;Margin:0;width:590px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr class="es-mobile-hidden" style="border-collapse:collapse"><td style="padding:0;Margin:0;font-size:0px" align="center"><a target="_blank" href="https://marabunta.work/marbymarabunta" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, "helvetica neue", helvetica, sans-serif;font-size:14px;text-decoration:underline;color:#333333"><img class="adapt-img" src="https://xnwii.stripocdn.email/content/guids/CABINET_4cfc1d6bdd1d23817dc262e13f9b8e66/images/81521602814921849.jpg" alt="Mar by Marabunta" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" title="Mar by Marabunta" width="590"></a></td></tr></table></td></tr></table></td></tr><tr style="border-collapse:collapse"><td align="left" style="padding:5px;Margin:0"><table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td valign="top" align="center" style="padding:0;Margin:0;width:590px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">' 
        +'<!--[if !mso]><!-- --><tr class="es-desk-hidden" style="display:none;float:left;overflow:hidden;width:0;max-height:0;line-height:0;mso-hide:all;border-collapse:collapse"><td style="padding:0;Margin:0;font-size:0px" align="center"><a target="_blank" href="https://marabunta.work/marbymarabunta" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, "helvetica neue", helvetica, sans-serif;font-size:14px;text-decoration:underline;color:#333333"><img class="adapt-img" src="https://xnwii.stripocdn.email/content/guids/CABINET_4cfc1d6bdd1d23817dc262e13f9b8e66/images/58701602814924013.jpg" alt="" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" title=""></a></td></tr>' 
        +'<!--<![endif]--></table></td></tr></table></td></tr></table></td></tr></table></td></tr></table></div></body></html>';
				
      this.$loadScript("https://smtpjs.com/v3/smtp.js")
        .then(() => {
            window.Email.send({
              SecureToken : "322d6962-0e3f-43ce-83e9-ed100b375248",
              To : obj.email,
              From : "no-reply@marabunta.work",
              Subject : "¡Bienvenido a Mar by Marabunta!",
              Body : htmlClient,
            }).then(
							message => {
								// console.log(message)
								if(message != "OK"){
									console.log("Error");
								}else{
									console.log("OK");
                  this.sendEmailAdminMar(obj);  
								}
							} 
            );
        })
        .catch((evt) => {
        // Failed to fetch script
          console.log(evt);
        });
		},
		sendEmailAdminMar(obj){
      var htmlAdmin='<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:arial, "helvetica neue", helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0"><head><meta http-equiv="Content-Security-Policy" content="script-src "none"; connect-src "none"; object-src "none"; form-action "none";"><meta charset="UTF-8"><meta content="width=device-width, initial-scale=1" name="viewport"><meta name="x-apple-disable-message-reformatting"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta content="telephone=no" name="format-detection"><title></title> '
        +'<!--[if (mso 16)]>'
        +'    <style type="text/css">'
        +'    a {text-decoration: none;}'
        +'    </style>'
        +'    <![endif]--> '
        +'<!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]--> '
        +'<!--[if gte mso 9]>'
        +'<xml>'
        +'    <o:OfficeDocumentSettings>'
        +'    <o:AllowPNG></o:AllowPNG>'
        +'    <o:PixelsPerInch>96</o:PixelsPerInch>'
        +'    </o:OfficeDocumentSettings>'
        +'</xml>'
        +'<![endif]--><style type="text/css">#outlook a {	padding:0;}.ExternalClass {	width:100%;}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div {	line-height:100%;}.es-button {	mso-style-priority:100!important;	text-decoration:none!important;}a[x-apple-data-detectors] {	color:inherit!important;	text-decoration:none!important;	font-size:inherit!important;	font-family:inherit!important;	font-weight:inherit!important;	line-height:inherit!important;}.es-desk-hidden {	display:none;	float:left;	overflow:hidden;	width:0;	max-height:0;	line-height:0;	mso-hide:all;}@media only screen and (max-width:600px) { .contacto {font-size:24px!important; color:"#FFFFFF"!important;} p, ul li, ol li, a { font-size:16px!important; line-height:150%!important } h1 { font-size:30px!important; text-align:center; line-height:120%!important } h2 { font-size:26px!important; text-align:center; line-height:120%!important } h3 { font-size:20px!important; text-align:center; line-height:120%!important } h1 a { font-size:30px!important } h2 a { font-size:26px!important } h3 a { font-size:20px!important } .es-menu td a { font-size:13px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:block!important } .es-button { font-size:16px!important; display:block!important; border-left-width:0px!important; border-right-width:0px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:50%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } .es-desk-menu-hidden { display:table-cell!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }</style></head><body style="width:100%;font-family:arial, "helvetica neue", helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0"><div class="es-wrapper-color" style="background-color:#F6F6F6"> '
        +'<!--[if gte mso 9]>'
        +'			<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">'
        +'				<v:fill type="tile" color="#f6f6f6"></v:fill>'
        +'			</v:background>'
        +'		<![endif]--><table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top"><tr style="border-collapse:collapse"><td valign="top" style="padding:0;Margin:0"><table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%"><tr style="border-collapse:collapse"><td align="center" style="padding:0;Margin:0"><table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px"><tr style="border-collapse:collapse"><td style="padding:0;Margin:0;padding-top:10px;padding-left:20px;padding-right:20px;background-color:#04182E" bgcolor="#04182E" align="left"> '
        +'<!--[if mso]><table style="width:560px" cellpadding="0"'
        +'                           cellspacing="0"><tr><td style="width:180px" valign="top"><![endif]--><table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left"><tr style="border-collapse:collapse"><td class="es-m-p0r es-m-p20b" valign="top" align="center" style="padding:0;Margin:0;width:180px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td style="padding:0;Margin:0;font-size:0px" align="center"><img class="adapt-img" src="https://xnwii.stripocdn.email/content/guids/CABINET_cb902553b823275b91f5c05b364546e8/images/16541601503807608.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="100"></td></tr></table></td></tr></table> '
        +'<!--[if mso]></td><td style="width:20px"></td><td style="width:360px" valign="top"><![endif]--><table cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td align="left" style="padding:0;Margin:0;width:360px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td align="center" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px"><p style="class="contacto" Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-size:32px;font-family:arial, "helvetica neue", helvetica, sans-serif;line-height:48px;color:#FFFFFF">Contacto</p></td></tr></table></td></tr></table> '
        +'<!--[if mso]></td></tr></table><![endif]--></td></tr><tr style="border-collapse:collapse"><td align="left" style="padding:0;Margin:0;padding-top:20px;padding-left:20px;padding-right:20px"><table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td class="es-m-p0r" valign="top" align="center" style="padding:0;Margin:0;width:560px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td align="left" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-size:14px;font-family:arial, "helvetica neue", helvetica, sans-serif;line-height:21px;color:#333333">Alguien ha dejado una solicitud de contacto&nbsp;en el sitio web&nbsp;<b><a target="_blank" href="https://marabunta.work/marbymarabunta" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, "helvetica neue", helvetica, sans-serif;font-size:14px;text-decoration:underline;color:#333333">marabunta.work/marbymarabunta</a></b>, a continuación la información:<br><br><strong>Nombre:<span>&nbsp;</span></strong>'+obj.name+'<br><br><strong>Correo:<span>&nbsp;</span></strong>'+obj.email+'<br><br><strong>Asunto:<span>&nbsp;</span></strong>'+obj.issue+'<br><br><strong>Servicios de interes:<span>&nbsp;</span></strong>'+JSON.stringify(obj.value)+'<br><br><strong>Presupuesto aproximado:<span>&nbsp;</span></strong>'+obj.budget+'<br><br><strong>Mensaje:<span>&nbsp;</span></strong>'+obj.message+'</p></td></tr></table></td></tr></table></td></tr><tr style="border-collapse:collapse"><td align="left" style="padding:0;Margin:0;padding-top:20px;padding-left:20px;padding-right:20px"><table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td valign="top" align="center" style="padding:0;Margin:0;width:560px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td align="right" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-size:10px;font-family:arial, "helvetica neue", helvetica, sans-serif;line-height:20px;color:#333333">marabunta.work</p></td></tr></table></td></tr></table></td></tr></table></td></tr></table></td></tr></table></div></body></html>';
      
      this.$loadScript("https://smtpjs.com/v3/smtp.js")
        .then(() => {
            window.Email.send({
              SecureToken : "322d6962-0e3f-43ce-83e9-ed100b375248",
							To : 'hellomar@marabunta.work',
              From : "no-reply@marabunta.work",
              Subject : "Solicitud de contacto Mar by Marabunta",
              Body : htmlAdmin,
            }).then(
                message => {
                  // console.log(message)
                  if(message != "OK"){
                    console.log("Error");
                  }else{
                    console.log("OK");
                  }
                }
            );
        })
        .catch((evt) => {
        // Failed to fetch script
          console.log(evt);
        });
    }
	}
}
</script>